<template>
    <div class='alert alert-warning' id='filter-list' v-if='filter_desc.length > 0'>
        <strong>{{ t_active_filter }}</strong> {{ filter_desc }}
    </div>
</template>
<script>
    import toaster from "../common/toaster";

    export default {
        props: [
            'filter_from',
            'filter_to',
            ],
        data() {
            return {
                t_active_filter: Lang.langGet("Active Filter"),
                filters: [],
                filter_id: -1,
                filter_desc: '',
            }
        },
        methods: {
            load: function () {
                axios.post('/system/reporting/list-data-filter', {
                    project_id: Laravel.activeProject,
                    filter_id: this.filter_id
                }).then((response) => {
                    this.filters = response.data.data.filter;
                    this.show();
                }).catch(() => {
                    toaster.error(this.t_load_error);
                });
            },
            show: function () {
                this.filter_desc = '';

                for (var i in this.filters) {
                    var filter = this.filters[i];
                    if (filter.value !== '') {
                        var value = filter.value;
                        if (filter.type === 'date') {
                            value = value.replace(/:/, ' - ');
                            if (filter.value_) {
                                var values = filter.value_.split(':');
                                this.$emit('update:filter_from', values[0]);
                                this.$emit('update:filter_to', values[1]);
                            }
                        } else if (filter.type === 'float' || filter.type === 'date') {
                            value = value.replace(/:/, ' - ');
                        }else if (filter.type === 'bool' && value === '1') {
                            value = Lang.langGet("Yes");
                        } else if (filter.type === 'bool' && value === '0') {
                           value = Lang.langGet("No");
                        } else if (filter.type === 'multiselect') {
                           var validVals = [];
                           for (var index in value) {
                               if (value[index].value === true) {
                                   validVals.push(value[index].text);
                               }
                           }
                           value = validVals.join(', ');
                        }

                        if (value.length > 0) {
                            if (this.filter_desc.length > 0) {
                                this.filter_desc += ', ';
                            }

                            this.filter_desc += filter.name + ': "' + value + '"';
                        }
                    }
                }
            },
        },
        mounted() {
            EaseEventBus.listen('updateTable', (data) => {
                this.filter_id = data.filter;
                if (this.filter_id) {
                    this.load()
                }
            });
        }
    }
</script>
